import * as L from "leaflet";

export function removeAllDrawnLayers(map: L.Map) {
  // @ts-ignore: incomplete type
  map.pm.getGeomanLayers().forEach((layer) => layer.remove());
  // @ts-ignore: incomplete type
  map.pm.getGeomanDrawLayers().forEach((layer) => layer.remove());
}
